export const routes = [
  {
    path: '/account-settings/:tab?',
    name: 'AccountSettings',
    component: () => import('@/app/modules/lk/views/AccountSettings.vue'),
  },
];
